export { default } from "./SwiperChannel"
